<template>
  <div class="box-logistic">
    <titleBar :title="'物流信息'" @callback="goBack"  :callback="true" ></titleBar>
    <div class="top-logistic">
      <img
        src="../../assets/images/parent-card/icon-gift.png"
        alt=""
        class="img-tit"
      />
      <div class="tit-info">
        <p class="name">小盒家长大礼包 <i class="num">x1</i></p>
        <p class="price">
          <span class="orginal-price">￥0</span
          ><span class="now-price">￥50</span>
        </p>
      </div>
    </div>
    <div class="gray"></div>
    <div class="logistic-info">
      <h3 class="tit big">订单信息</h3>
      <ul class="info-box">
        <li class="tit">
          购买时间： {{ list.buyTime | formatDate("yyyy-MM-dd") }}
        </li>
        <li class="tit">
          <span id="contentp">物流单号： {{ list.logisticsNumber }}</span>
          <span class="btn-copy" @click="copyNumber()">复制</span>
        </li>
        <li class="tit address">
          收货地址：<span class="btn-copy" @click="goToAddress">修改</span>
        </li>
        <li>收件人：{{ list.name }}</li>
        <li>联系电话：{{ list.mobile }}</li>
        <li>
          地址：{{ list.province }}{{ list.city }}{{ list.district
          }}{{ list.address }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import titleBar from "@/components/common/titleBar.vue";
import utils from "@/assets/js/utils";
import ajax from "@/api/cardAjax";
const token = utils.getQueryString("token");
const version = utils.getQueryString("version");
const source = utils.getQueryString("source");

export default {
  name: "logistics",
  data() {
    return {
      list: {
        logisticsNumber: "", // 物流单号
        name: "", // 收件人
        mobile: "", // 联系电话
        province: "", // 省
        city: "", // 市
        district: "", // 地区
        address: "", // 具体地址
        buyTime: "", // 购买时间戳
      },
    };
  },
  components: {
    titleBar,
  },
  mounted(){
    this.getData();
  },
  created() {
     console.log(window.location.href,2)
  },
  methods: {
    async getData() {
      let timestamp = Date.parse(new Date());
      let resp  = await ajax.get(
        "/pay/return-money/get-logistics-progress",
        {
          params: { token, version, source,timestamp },
        }
      );
      if(resp.config) resp = resp.data;
      if (resp.code == 99999) {
        this.list = resp.data;
        console.log(45,resp,this.list)
      } else {
        this.$toast(resp.msg);
      }     
    },
    goToAddress() {
      let timestamp = Date.parse(new Date());
      this.$router.push(`/address?source=${source}&token=${token}&version=${version}&random=${timestamp}`);
    },
    copyNumber() {
      const range = document.createRange();
      range.selectNode(document.getElementById("contentp"));
      const selection = window.getSelection();
      if (selection.rangeCount > 0) selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand("copy");
      this.$toast("已复制到剪切板");
    },
    goBack(){
      let timestamp = Date.parse(new Date());
      this.$router.push(`/card/studyProgress?source=${source}&token=${token}&version=${version}&random=${timestamp}`);
      //window.location.href = `${window.location.href.split('logistics').join('studyProgress')}`;
      //this.$router.go(-1);
    }
  },
};
</script>
<style lang="scss" scoped>
.btn-copy {
  float: right;
  width: 1.18rem;
  height: 0.56rem;
  line-height: 0.5rem;
  background-color: #ffffff;
  border-radius: 0.28rem;
  border: solid 0.03rem #4babfb;
  text-align: center;
  font-family: PingFangSC-Medium;
  font-size: 0.24rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #4babfb;
}

.box-logistic {
  height: 100%;
  background: #fff;
  padding: 0.88rem 0 0;
  box-sizing: border-box;
}
.gray {
  width: 7.5rem;
  height: 0.2rem;
  background-color: #f6f6f8;
}
.box-logistic {
  .img-tit {
    width: 1.2rem;
    height: 1.2rem;
    background-color: #ffffff;
    border-radius: 0.08rem;
    border: solid 0.01rem rgba(0, 0, 0, 0.06);
  }
}
.top-logistic {
  padding: 0 0.4rem 0;
  display: flex;
  height: 2.14rem;
  align-items: center;
}
.logistic-info {
  height: 100%;
  padding: 0.4rem 0.3rem 3.83rem;

  .tit {
    height: 0.5rem;
    font-size: 0.36rem;
    margin: 0 0 0.1rem;
    color: #111f2c;
  }
  .big {
    font-weight: 700;
    font-size: 0.38rem;
    margin: 0 0 0.2rem;
  }
  .address {
    margin: 0.6rem 0 0;
  }
  .info-box {
    overflow: hidden;
  }
  li {
    height: 0.45rem;
    font-family: PingFangSC-Regular;
    font-size: 0.32rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0rem;
    color: #6a6e72;
    margin: 0.1rem 0;
  }
}
.price {
  .orginal-price {
    width: 0.36rem;
    height: 0.42rem;
    font-family: PingFangSC-Semibold;
    font-size: 0.3rem;
    font-weight: normal;
    font-stretch: normal;
    line-height: 0.42rem;
    letter-spacing: 0rem;
    color: #ff571d;
  }
  .now-price {
    width: 0.44rem;
    height: 0.33rem;
    font-family: PingFangSC-Regular;
    font-size: 0.24rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0rem;
    color: #bec0c2;
    margin: 0 0 0 0.14rem;
    text-decoration: line-through;
  }
}
.tit-info {
  margin: 0 0 0 0.24rem;
  flex: 1;
  .name {
    // width: 2.52rem;
    height: 0.5rem;
    font-family: PingFangSC-Medium;
    font-size: 0.36rem;
    font-weight: normal;
    font-stretch: normal;
    line-height: 0.5rem;
    letter-spacing: 0rem;
    color: #161616;
  }
  .num {
    width: 0.24rem;
    height: 0.32rem;
    font-family: PingFangSC-Regular;
    font-size: 0.26rem;
    font-weight: normal;
    font-stretch: normal;
    line-height: 0.32rem;
    letter-spacing: 0rem;
    color: #9aa0a5;
    margin: 0 0 0 0.18rem;
    // float:right;
  }
}
</style>
